import type { TFunction } from "i18next";

/**
 * Countdown leigo do auto-resume (LAC-138 detalhe · LAC-194 lista).
 * Só faz sentido na 1ª pausa circuit/platform com ETA — 2ª+ = só SA.
 */
export type CircuitAutoResumeCopyMode = "detail" | "list";

export function hasCircuitAutoResumeEta(input: {
  status?: string;
  pause_reason?: string | null;
  circuit_auto_resume_eta_at?: string | null;
  needs_sa_resume?: boolean;
}): boolean {
  if (input.status !== "paused") {
    return false;
  }
  if (
    input.pause_reason !== "circuit" &&
    input.pause_reason !== "platform"
  ) {
    return false;
  }
  if (input.needs_sa_resume || !input.circuit_auto_resume_eta_at) {
    return false;
  }
  return true;
}

export function formatCircuitAutoResumeCountdown(
  etaIso: string | null | undefined,
  needsSaResume: boolean | undefined,
  nowMs: number,
  t: TFunction,
  mode: CircuitAutoResumeCopyMode = "detail"
): string | null {
  if (!etaIso || needsSaResume) {
    return null;
  }
  const ms = new Date(etaIso).getTime() - nowMs;
  if (Number.isNaN(ms)) {
    return null;
  }
  const prefix =
    mode === "list"
      ? "sending.list.circuitPaused"
      : "sending.detail.circuitPaused";
  if (ms <= 0) {
    return t(`${prefix}.etaSoon`);
  }
  const mins = Math.ceil(ms / 60000);
  if (mins < 60) {
    return t(`${prefix}.etaCountdownMin`, { count: mins });
  }
  const hours = Math.floor(mins / 60);
  const rem = mins % 60;
  return rem > 0
    ? t(`${prefix}.etaCountdownHourMin`, { hours, mins: rem })
    : t(`${prefix}.etaCountdownHour`, { count: hours });
}
